const useCurrentPageProp = { currentPage: { type: Number } };
const useItemsProp = { items: { type: Array, default: () => [] } };
const useSelectableProp = { selectable: { type: Boolean, default: false } };
const useItemsTrackByProp = { itemsTrackBy: { type: [String, Function], default: "" } };
export {
  useItemsProp as a,
  useItemsTrackByProp as b,
  useSelectableProp as c,
  useCurrentPageProp as u
};
//# sourceMappingURL=useCommonProps-59d5fc97.mjs.map
